module.exports = __webpack_public_path__ + "static/media/buffet14.2e7c9e85.jpg";